import React, {useState, useMemo, useEffect} from "react";
import {useDispatch} from "react-redux";
import {faqAreasAction} from "redux/actions";
import {TabModal} from "components";
import Details from "./Details";
import ImageFileUpload from "./ImageFileUpload";

export default function CategoryPopup({closeModal, data}) {
    // redux
    const dispatch = useDispatch();

    // states
    const [tabIndex, setTabIndex] = useState(0); //Popup tab active or inactive state
    const [details, setDetails] = useState(); // Sub Category Details

    // useEffects
    useEffect(() => {
        if (!data) return;
        setDetails(data);
    }, []);

    // Handle change in Details Form
    const handleChange = e => {
        setDetails({
            ...details,
            [e.target.name]: e.target.value
        });
    };

    // Handle Image Select
    const handleImageSelect = e => setDetails({...details, image: e});

    // On Submit Data to Server
    const submit = () => {
        setTabIndex(0);
        closeModal();
        if (data) return dispatch(faqAreasAction.update(details));

        dispatch(faqAreasAction.add(details));
    };

    // Popup tabs routes
    const modalTabs = useMemo(
        () => [
            {
                name: "FAQ Area Details",
                component: (
                    <Details
                        onClick={e => setTabIndex(1)}
                        details={details}
                        setDetails={handleChange}
                    />
                )
            },
            {
                name: "FAQ Area Image",
                component: (
                    <ImageFileUpload
                        onClick={submit}
                        onImageSelect={handleImageSelect}
                        imageSrc={details?.image}
                    />
                )
            }
        ],
        [details]
    );

    return (
        <TabModal
            tabTitle={data ? "Edit FAQ Area" : "Create New FAQ Area"}
            tabs={modalTabs}
            tabIndex={tabIndex}
            setTabIndex={index => setTabIndex(index)}
            closeModal={() => {
                setTabIndex(0);
                closeModal();
            }}
        />
    );
}
